<app-dialog [visible]="visible()" (closed)="onDialogHide()" title="Saved memories"
    [fullscreenOnMobile]="true" class="max-w-[650px]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col items-start gap-4 justify-between w-full">
            <div class="flex-1">
                <div class="text-sm text-gray-600">
                    Bob remembers and automatically manages useful information from chats, making responses more
                    relevant and personal
                </div>
            </div>
            <div class="flex justify-between items-center w-full gap-6">
                <app-search-bar placeholder="Search memories" class="w-full" [value]="searchQuery()"
                    (searchChange)="onSearchChange($event)"></app-search-bar>
                <div class="flex-shrink-0">
                    <app-menu #filterMenu [items]="getFilterMenuItems()">
                        <app-button (clicked)="filterMenu.toggle($event)" variant="outlined" severity="contrast"
                            pTooltip="More" icon="pi pi-ellipsis-v" iconSource="primeng"></app-button>
                    </app-menu>
                </div>
            </div>
            <div class="flex-1 overflow-y-auto space-y-2 max-h-[60vh] w-full" infiniteScroll
                [infiniteScrollThrottle]="300" (scrolled)="loadMore()" [infiniteScrollDistance]="1"
                [scrollWindow]="false">
                @for (item of filteredMemories; track item.s3Key + '-' + item.lineIndex; let i = $index) {
                @if (item.content.length > 0) {
                <div class="group relative p-4 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer ">
                    @if (editingS3Key() === item.s3Key && editingLineIndex() === item.lineIndex) {
                    <div class="flex flex-col gap-3">
                        <textarea [(ngModel)]="editContent" rows="4"
                            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none">
                        </textarea>
                        <div class="flex justify-end gap-2">
                            <app-button (clicked)="cancelEdit()" variant="outlined" severity="contrast" label="Cancel">
                            </app-button>
                            <app-button (clicked)="handleSaveEdit(item.s3Key, item.lineIndex)" [enableThrottle]="true"
                                severity="primary" label="Save">
                            </app-button>
                        </div>
                    </div>
                    } @else {
                    <div class="flex items-start justify-between gap-3">
                        <p class="text-sm text-gray-800 leading-relaxed flex-1">
                            {{ item.content }}
                        </p>
                        <div class="flex-shrink-0 transition-opacity duration-150">
                            <app-menu #menu [items]="getMenuItems(item.s3Key, item.lineIndex)">
                                <app-button (clicked)="menu.toggle($event)" variant="outlined" severity="contrast"
                                    pTooltip="More" icon="pi pi-ellipsis-v" iconSource="primeng"></app-button>
                            </app-menu>
                        </div>
                    </div>
                    <div class="mt-2 flex items-center gap-1 text-xs text-gray-500">
                        @if (item.createdAt) {
                        <span>Saved on {{ item.createdAt | date:'dd/MM/yyyy' }} in</span>
                        } @else {
                        <span>Saved in</span>
                        }
                        <a (click)="openChat(item)" class="cursor-pointer underline">
                            Chat
                        </a>
                    </div>
                    }
                </div>
                }
                } @empty {
                @if (!loading()) {
                <div class="text-center py-12 text-gray-500">
                    <i class="pi pi-inbox text-4xl mb-3 block"></i>
                    <p class="text-sm">No memories found</p>
                </div>
                }
                }
                @if (loading()) {
                <div class="text-center py-4 text-gray-400">
                    <i class="pi pi-spinner pi-spin text-xl"></i>
                </div>
                }
            </div>
        </div>
    </ng-template>
</app-dialog>

@if(deleteConfirmationVisible()){
<app-delete-confirmation [visible]="deleteConfirmationVisible()" (visibleChange)="deleteConfirmationVisible.set($event)"
    [headerText]="isDeleteAll() ? 'Delete All Memories?' : 'Delete Memory?'"
    [bodyText]="isDeleteAll() ? 'This action will delete all memories' : 'This action will delete the memory'"
    confirmButtonText="Proceed" (onConfirm)="handleDeleteConfirmation()">
</app-delete-confirmation>
}
